// import types
import { TabType } from './types';
import type { CareReceiverHandover, Patient } from './types';

/**
 * Care receiver labels arrive from the backend as "lastName, firstName". Split in one place so a
 * care receiver handed over from another page yields the same names a manual search selection does.
 */
export const splitCareReceiverName = (label?: string) => ({
  firstName: label?.split(',')[1]?.trim() || '',
  lastName: label?.split(',')[0]?.trim() || label || ''
});

/**
 * Builds the Patient this page works with from a session storage handover. Only the id is needed to
 * fetch details and prescriptions; the label is carried over so the search box is filled in before
 * those requests resolve, instead of looking as though nothing is selected.
 */
export const careReceiverHandoverToPatient = ({
  careReceiverId,
  name
}: CareReceiverHandover): Patient => ({
  id: careReceiverId,
  entityId: careReceiverId,
  name,
  displayName: name,
  ...splitCareReceiverName(name)
});

/** Guards a `page` hash param before it is trusted as a tab. */
export const isTabType = (value?: string): value is TabType =>
  Object.values(TabType).includes(value as TabType);
